import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import Logo from './Logo';
import { CONTACT_EMAIL } from '../data/content';

export default function Footer() {
  return (
    <footer className="bg-navy-deep text-slate-300 mt-28 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-royal/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-sm">
              Three specialist tipsters — a Daily Double, an Asian Handicap single and a daily single. One release per tipster per day, and an archive that records every day, the good ones and the bad ones.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow text-white/60 mb-4">Service</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/#tipsters" className="hover:text-white transition-colors">The tipsters</Link></li>
              <li><Link to="/#why" className="hover:text-white transition-colors">Why three specialists</Link></li>
              <li><Link to="/results" className="hover:text-white transition-colors">Results archives</Link></li>
              <li><Link to="/#pricing" className="hover:text-white transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow text-white/60 mb-4">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/#faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/admin" className="hover:text-white transition-colors text-slate-500">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow text-white/60 mb-4">Contact</h4>
            <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors break-all" data-testid="footer-email">
              <Mail className="w-4 h-4 flex-shrink-0" /> {CONTACT_EMAIL}
            </a>
            <p className="mt-4 text-xs text-slate-500 leading-relaxed">We reply to every message within 12 hours, usually much sooner.</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-xs text-slate-500 leading-relaxed max-w-2xl">
            © {new Date().getFullYear()} Top 3 Football Tipsters. 18+ only. Football betting involves risk and past results do not guarantee future outcomes. Please bet responsibly.
          </div>
          <div className="flex gap-6 text-xs text-slate-400">
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/responsible-gambling" className="hover:text-white">Responsible Gambling</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
